/*eslint-disable*/
import React from 'react';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { Dashboard } from '@material-ui/icons';
// core components
import Button from 'components/CustomButtons/Button.jsx';
import withUser from '../HOC/HOCwithUser.jsx';
import headerLinksStyle from 'assets/jss/material-kit-react/components/headerLinksStyle.jsx';
import { CircularProgress, Select, MenuItem } from '@material-ui/core';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ROLE_PROVIDER, ROLE_CUSTOMER } from '../../utils/config/constants.js';

class MainPageLinks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            signupRedirect: false,
            dashboardRedirect: false,
            language: 'en'
        };
    }
    handleChangeLanguage = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
        document.documentElement.lang = event.target.value;
        this.props.changeLanguageAction({ language: event.target.value });
    };

    renderSignin = () => {
        this.props.history.push('/user/signin');
    };

    render() {
        const { classes, userData } = this.props;
        const { dashboardRedirect } = this.state;
        if (this.state.signupRedirect) {
            this.props.history.push(`/signup`);
        }
        if (dashboardRedirect) {
            if (this.props.userData.role == ROLE_PROVIDER) {
                this.props.history.push(`/user/dashboard`);
            } else if (this.props.userData.role == ROLE_CUSTOMER) {
                this.props.history.push(`/user/profile`);
            }
        }

        if (this.props.isLoading) {
            return <CircularProgress />;
        }
        if (!userData.name) {
            return (
                <List className={classes.list + ' navigation-right'}>
                    <ListItem
                        className={classes.listItem}
                        style={{ color: '#ffffff' }}
                    >
                        <Button
                            target="_blank"
                            color="transparent"
                            className={classes.navLink + ''}
                            onClick={() => {
                                this.setState({ signupRedirect: true });
                            }}
                        >
                            <FormattedMessage
                                id="Register"
                                defaultMessage="Register"
                            />
                        </Button>
                    </ListItem>

                    <ListItem
                        className={classes.listItem}
                        style={{ color: '#ffffff' }}
                    >
                        <Button
                            target="_blank"
                            color="transparent"
                            className={classes.navLink + ''}
                            onClick={this.renderSignin}
                        >
                            <FormattedMessage
                                id="header.Sign In"
                                defaultMessage="Sign In"
                            />
                        </Button>
                    </ListItem>

                    {/* <ListItem className={classes.listItem}>
                        <Select
                            className="btn-login"
                            style={{ color: '#ffffff' }}
                            value={this.state.language}
                            onChange={this.handleChangeLanguage}
                            name="language"
                        >
                            <MenuItem value="en">English</MenuItem>
                            <MenuItem value="de">German</MenuItem>
                        </Select>
                    </ListItem> */}
                </List>
            );
        } else {
            return (
                <List className={classes.list + ' navigation-right'}>
                    <ListItem
                        className={classes.listItem}
                        style={{ color: '#ffffff' }}
                    >
                        <Button
                            target="_blank"
                            color="transparent"
                            className={classes.navLink}
                            onClick={() =>
                                this.setState({ dashboardRedirect: true })
                            }
                        >
                            <Dashboard className={classes.icons} />{' '}
                            <FormattedMessage
                                id="header.dashboard"
                                defaultMessage="Dashboard"
                            />
                        </Button>
                    </ListItem>
                    {this.props.userData.role == ROLE_CUSTOMER && (
                        <ListItem
                            className={classes.listItem}
                            style={{ color: '#ffffff' }}
                        >
                            {/* <Badge
                                badgeContent={
                                    this.props.cartDetail.items
                                        ? this.props.cartDetail.items.length
                                        : 0
                                }
                            >
                                <Button
                                    target="_blank"
                                    color="transparent"
                                    className={
                                        (classes.navLink =
                                            '  btn-dash-cart mt-0')
                                    }
                                    onClick={
                                        () => this.redirectToCart()
                                        //this.setState({ cartRedirect: true })
                                    }
                                >
                                    <ShoppingCart />
                                </Button>
                            </Badge> */}
                        </ListItem>
                    )}
                    {/* <ListItem className={classes.listItem}>
                        <Select
                            className=""
                            style={{ color: '#ffffff' }}
                            value={this.props.currentLanguage}
                            onChange={this.handleChangeLanguage}
                            name="language"
                        >
                            <MenuItem value="en">English</MenuItem>
                            <MenuItem value="ar">Arabic</MenuItem>
                        </Select>
                    </ListItem> */}
                </List>
            );
        }
    }
}

const mapStateToProps = ({ auth, settings }) => {
    return {
        userData: auth.userData,
        currentLanguage: settings.currentLanguage
    };
};

const composedComponent = compose(
    withStyles(headerLinksStyle),
    connect(
        mapStateToProps,
        null
    )
);
export default composedComponent(withRouter(withUser(MainPageLinks)));



// WEBPACK FOOTER //
// ./src/components/Header/MainPageLinks.js